// @ts-nocheck
import {
    chain,
    RequestDataFromApi as BaseRequestDataFromApi,
} from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import { getCategories } from "@store/Modules/client-framework/src/Services/CategoryService";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

/* Store Custom Code - Import path for "getCategories" is different but the handler code is untouched */
export const RequestDataFromApi = createChainHandler("RequestDataFromApi", chain, async props => {
    try {
        props.apiResult = await getCategories(props.apiParameter);
    } catch (error) {
        if (error?.status === 404) {
            if (props.apiParameter.startCategoryId) {
                props.dispatch({
                    type: "Data/Categories/FailedToLoadCategory",
                    categoryId: props.apiParameter.startCategoryId,
                    status: error.status,
                });
            }
            return false;
        }
        throw error;
    }
});

replaceInChain(chain, BaseRequestDataFromApi, RequestDataFromApi);
